import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { RouteService } from '../../../services/route.service'
import { ROUTES } from '../../../constants/routes'
import { Product } from '../../../types/products'
import { MatDivider } from '@angular/material/divider'
import { MatToolbar } from '@angular/material/toolbar'
@Component({
  selector: 'app-product-scores',
  imports: [MatDivider, MatToolbar],
  templateUrl: './product-scores.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-scores.component.scss',
})
export class ProductScoresComponent {
  private route = inject(ActivatedRoute)

  constructor() {
    const routeService = inject(RouteService)

    const productId = this.route.parent?.snapshot.params['id']
    if (!productId) {
      // TODO - throw error
    }

    const currentRoute = routeService.getProductViewRoutes(
      this.product.name,
      ROUTES.PRODUCT_SCORES.path,
      productId,
    )
    routeService.setRoute(currentRoute)
  }

  product: Product = {
    name: "Men's Skagen Offshore Sailing Jacket",
    id: '007',
    brand: 'Helly Hansen',
    imageUrl:
      'https://www.hellyhansen.com/media/catalog/product/3/4/34255_222-1-onbody1.jpg?auto=webp&format=pjpg&fit=cover&height=640&width=640"',
    price: 490.0,
    scores: {
      overallSustainabilityScore: 93,
      condition: 'Used',
      componentIdentifier: 'Test Identifier',
      cffEmissions: 'Test Emission',
      waterUsage: 'Test Water Usage',
      netZeroScore: 82,
      bioDiversityScore: 90,
      modernSlaveryScore: 0,
    },
  }
}
